module.exports = "/_next/static/images/d255b4dd0f9f9494011e2b497901ef75-defer.png";